var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M10 10h28v28H10z" }),
            React.createElement("path", { d: "M24 19.286c-2.511 0-4.545 2.11-4.545 4.714 0 2.604 2.034 4.714 4.545 4.714s4.545-2.11 4.545-4.714c0-2.604-2.034-4.714-4.545-4.714zm10.16 3.536c-.524-4.915-4.285-8.815-9.024-9.357v-1.292a1.136 1.136 0 10-2.272 0v1.292c-4.739.542-8.5 4.442-9.023 9.357h-1.163a1.178 1.178 0 000 2.356h1.163c.523 4.915 4.284 8.815 9.023 9.357v1.292a1.136 1.136 0 102.272 0v-1.292c4.739-.542 8.5-4.442 9.023-9.357h1.163a1.178 1.178 0 000-2.356h-1.163zM24 32.249c-4.398 0-7.955-3.688-7.955-8.249 0-4.56 3.557-8.25 7.955-8.25s7.955 3.69 7.955 8.25c0 4.56-3.557 8.25-7.955 8.25z", fill: "currentColor", fillRule: "nonzero" }))));
});
